import React, { useEffect } from 'react';
import { Actions as USAGEACTIONS } from '../store/actions/usageActions';
import { Actions as ADMINACTIONS } from '../store/actions/adminActions';
import { connect } from 'react-redux';
import UsageData from '../components/UsageData/UsageData';
import Breadcrumb from '../components/Common/Breadcrumb';
import { NoPermissions } from '../components/Common/ReusableComponents/Reusable';

const Usage = ({
  organisation,
  getUsageTotals,
  processing,
  branding,
  industriesList,
  currencies,
  getAllItemsFromDB,
  hasAccess,
  permissions,
}) => {
  const { headers } = branding?.fonts?.[0]?.font;

  useEffect(() => {
    if (!currencies) {
      getAllItemsFromDB('currencies');
    }
    //eslint-disable-next-line
  }, []);

  if (permissions != undefined && !hasAccess) return <NoPermissions />;

  return (
    <React.Fragment>
      <Breadcrumb items={[{ label: 'Usage', link: '/usage' }]} />

      <div className='row' style={{ fontFamily: headers }}>
        <div className='col-lg-12'>
          <section className='panel'>
            <aside className='profile-nav alt'>
              <section className='panel'>
                <header className='panel-heading'>
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    Usage data - {organisation?.name}
                    {!processing && (
                      <i
                        id='refreshUsage'
                        className={'fa fa-refresh'}
                        style={{ cursor: 'pointer' }}
                        onClick={() => getUsageTotals()}
                      />
                    )}
                    {processing && <i className='fa fa-spin fa-spinner' />}
                  </div>
                </header>
                <ul className='nav nav-pills nav-stacked'>
                  <li>
                    <div style={{ padding: '10px 15px' }}>
                      <i style={{ paddingRight: '10px' }} className='fa fa-calendar'></i> Reporting year end{' '}
                      <span style={{ float: 'right' }}>
                        {organisation?.reportingYearEndDay}/{organisation?.reportingYearEndMonth}
                      </span>
                    </div>
                  </li>
                  <li>
                    <div style={{ padding: '10px 15px' }}>
                      <i style={{ paddingRight: '10px' }} className='fa fa-bookmark'></i> Industry sector
                      <span style={{ float: 'right' }}>
                        {industriesList?.find((i) => i.id === organisation?.industry)?.name}
                      </span>
                    </div>
                  </li>
                </ul>
              </section>
            </aside>
          </section>
        </div>
      </div>

      <UsageData />
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    organisation: state.organisation?.details,
    industriesList: state.organisation?.industries,
    processing: state.usageProcessing,
    branding: state.branding,
    currencies: state.admin?.adminPortal?.currencies,
    hasAccess: !!state.organisation?.permissions?.usageData?.view,
    permissions: state.organisation?.permissions,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getUsageTotals: () => dispatch(USAGEACTIONS.getUsageTotals()),
  getAllItemsFromDB: (table) => dispatch(ADMINACTIONS.getAllItemsFromDB(table)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Usage);
